import alert from '@/plugins/alert'
import { Transcript } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    transcript: {},
    transcripts: []
  },
  actions: {
    async fetchTranscript ({ commit }, transcriptId) {
      commit('setTranscript', await Transcript.fetchOne(transcriptId))
    },
    async fetchTranscripts ({ commit }, criteria) {
      commit('setTranscripts', await Transcript.fetch(criteria))
    },
    async createTranscript ({ commit }, { data, options }) {
      commit('setTranscript', await Transcript.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async removeTranscript ({ commit }, id) {
      await Transcript.remove(id)
      commit('removeTranscript', id)
      alert.success('Xóa thành công!')
    },
    setTranscript ({ commit }, transcript) {
      commit('setTranscript', transcript)
    },
    async updateTranscript ({ commit }, { id, ...transcript }) {
      try {
        commit('setTranscript', await Transcript.update(id, transcript))
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setTranscript (state, transcript) {
      state.transcript = transcript
    },
    setTranscripts (state, transcripts) {
      state.transcript = transcripts
    },
    removeTranscript (state, id) {
      state.transcripts = state.transcripts.filter(t => t.id !== id)
    }
  },
  getters: {
    transcript: state => id => {
      return state.transcript
    },
    transcripts: state => id => {
      return state.transcript
    }
  }
}
